import { formActionTypes,UPDATEFORM,RESETFORM } from '../types/userManagementTypes';
export interface FormState{
    fName:string,
    lName:string,
    userType:string,
    designation:string,
    mob:string,
    altMob:string,
    email:string,
    doj:string,
    state:string,
    district:string,
    ruralUrban:string,
    ulb:string,
    subDistrict:string,
    block:string,
    healthBlock:string,
    subDivision:string,
    ward:string,
    village:string,
    userStatus:string,
    mfa:string,
    offlineModeAccess:string,
    lineListingData:string,
    hfrAbha:string,
    role:string,
    hfr:string,
    healthFacilityType:string,
    healthFacilityName:string,
    ashaTagged:string,
    healthProviderTagged:string,
    volunteerForPMSMA:string,
    isVerified:string,
    file: File | null,
    isEditButtonCLicked:boolean,
    userName:any,
    linkedFacilityId:string,
    isFacilityDeleted:boolean,
    isOkButtonClicked:boolean,
    isLinkUnLinkButtonCLicked:boolean,
    stateId:string,
    districtId:string,
    ishprEntered:boolean,
    hprNullCheck:boolean,
    hprNumberCheck:boolean,
    hpr_id:string,
    unlinkPayload:any,
    navigateShiftTransfer:boolean,
    navigateLinkPayload:boolean,
    linkedFacilityCount:number,
    isNotVerified:boolean,
    clearHpr:boolean,
    isUserActive:boolean,
    userRoles:{
      [x: string]: any;
      role_id: string;
      role_code: number;
      role_name: string;
    },
    edit_privilege_flow: boolean,
    role_payload:{
      page_id: string;
      privilege_ids:string[];
    },
    userStatusUpdate: string,
    compositeRoleId: string,
    isPrivilegeSelected: boolean,
    consentDetails:any,
    verificationProcessId:string
  }
  const initialState: FormState={
    fName:'',
    lName:'',
    userType:'',
    designation:'',
    mob:'',
    altMob:'',
    email:'',
    doj:'',
    state:'',
    district:'',
    ruralUrban:'',
    ulb:'',
    subDistrict:'',
    block:'',
    healthBlock:'',
    subDivision:'',
    ward:'',
    village:'',
    userStatus:'',
    mfa:'',
    offlineModeAccess:'',
    lineListingData:'',
    hfrAbha:'',
    role:'',
    hfr:'',
    healthFacilityType:'',
    healthFacilityName:'',
    ashaTagged:'',
    healthProviderTagged:'',
    volunteerForPMSMA:'',
    isVerified:'',
    file:null,
    isEditButtonCLicked:false,
    linkedFacilityId:'',
    isFacilityDeleted:false,
    isLinkUnLinkButtonCLicked:false,
    stateId:'',
    districtId:'',
    hpr_id:'',
    linkedFacilityCount:0,
    navigateShiftTransfer:false,
    navigateLinkPayload:false,
    isOkButtonClicked:false,
    ishprEntered:false,
    hprNullCheck:false,
    clearHpr:false,
    hprNumberCheck:false,
    isNotVerified:false,
    unlinkPayload:{},
    isUserActive:true,
    userRoles:{
      role_name: '',
      role_id: '',
      role_code: 0
    },
    edit_privilege_flow: false,
    role_payload:{
      page_id: '',
      privilege_ids:[]
    },
    userName:0,
    userStatusUpdate:'',
    compositeRoleId: '',
    isPrivilegeSelected:true,
    consentDetails:[],
    verificationProcessId:''
  }

const userReducer =(
    state =initialState,
    action:formActionTypes,
): FormState=>{
      switch(action.type){
        case UPDATEFORM:
          return{...state,[action.payload.field]:
            action.payload.value,
          };
          case RESETFORM:
            return initialState;
          default :
            return state
        
      }
    }

    export default userReducer;